import { store, store$ } from '@redux/store';
import { map, distinctUntilChanged, pairwise, distinctUntilKeyChanged } from 'rxjs';
import CardGridSkeleton from '@components/skeletons/cardSkeleton';
import uiStateSlice from 'layout/redux/uiStateSlice';
import ResultPresentationType from 'layout/constants/resultPresentationType';
import { selectFetchResultListingsStatus } from '../../../features/searchResultsFacets/redux/selectors';
import { selectDisplaySkeletonAndResultsPresentationType } from '../redux/selectors';

const listViewContainerSelector = '[data-list-view-element]';
const skeleton = new CardGridSkeleton();
const uiStateActions = uiStateSlice.actions;

// will look for changes in the fetching result state, which determines that results are buein requested.
const onFetchingResultsChanged$ = store$.pipe(map(selectFetchResultListingsStatus), distinctUntilChanged());

// triggers a change in the ui state to flag is skeleton should be displayed
const triggerUpdateSkeleton = (fetchResultListingsStatus) => {
  store.dispatch(uiStateActions.updateCardGridSkeleton(fetchResultListingsStatus));
};

onFetchingResultsChanged$.subscribe(triggerUpdateSkeleton);

// method to toggle the behavior of the skeleton component
const displayCardGridSkeleton = (displaySkeletonInformation) => {
  setTimeout(() => {
    skeleton.containerSelector = listViewContainerSelector;
    skeleton.cardCount = document.querySelectorAll(
      `${listViewContainerSelector} div[data-native], [data-card], [data-builder-brand-card]`
    ).length;
    skeleton.destroy();

    if (!displaySkeletonInformation.shouldDisplaySkeleton) {
      return;
    }

    if (displaySkeletonInformation.shouldCleanUpContainer) {
      document.querySelector(listViewContainerSelector).innerHTML = '';
    }

    if (displaySkeletonInformation.resultsPresentationType === ResultPresentationType.InfiniteScrolling.toString()) {
      skeleton.concat();
    } else {
      skeleton.create();
    }
  });
};

/**
 * This observable subscribes to the store and observe changes in the display skeleton property and the
 * page layout property.
 * The observable maps information so their subscribers can determine if they should show the skeleton and
 * the way of showing it depending on the way we are presenting results to the user, ie: pagination, infinite scroll...
 * By the pairwise operator, we know if we should clean up the container before rendering the skeleton or not. If
 * we come from a change in the page layout, we will always clean up the container where the skeleton is going
 * to be rendered. For example: moving from Home results to Community Results. On the other hand, if we come from
 * an identical page layout, we are not going to clean the container first, since we could be presenting results
 * in an infinite scrolling way, so we need to preserve previous results and concat the skeleton after them.
 */
const onDisplaySkeletonChange$ = store$.pipe(
  map(selectDisplaySkeletonAndResultsPresentationType),
  distinctUntilKeyChanged('shouldDisplaySkeleton'),
  pairwise(),
  map((stateTransition) => ({
    shouldDisplaySkeleton: stateTransition[1].shouldDisplaySkeleton,
    resultsPresentationType: stateTransition[1].resultsPresentationType,
    shouldCleanUpContainer: stateTransition[0].resultsPresentationType !== stateTransition[1].resultsPresentationType,
  }))
);

// subscribe to the observable and call the toggleClearAllButton function
onDisplaySkeletonChange$.subscribe(displayCardGridSkeleton);
